module.exports = __webpack_public_path__ + "img/tax_button.d55fdb26.png";